<article>
  <header>
    <strong>Relação Short Calls e Total de Ligações</strong>
  </header>
  <main>
    <app-pie-chart
      [inlineLegend]="true"
      [inlineContainer]="true"
      [loading]="loading"
      [error]="error"
    ></app-pie-chart>
  </main>
</article>
